import React, { useRef, useEffect } from "react";
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import logo from "../img/logo.png";

const Category = () => {
  const { category, info, cafe, table } = useLocation().state;
  const history = useHistory();
  const [image, setImage] = useState(null);
  const lang = localStorage.getItem("alka-menu-lang") || "tr";
  const modalRef = useRef();
  const [cartItemsCount, setCartItemsCount] = useState(0);

  useEffect(() => {
    // Sepet verilerini localStorage'dan al ve sayısını hesapla
    const cartData = JSON.parse(localStorage.getItem(cafe + "-cart")) || [];
    if (Array.isArray(cartData)) {
      setCartItemsCount(cartData.length);
    } else if (typeof cartData === "string") {
      try {
        // Bazen JSON string olarak kayıtlı olabilir
        const parsedCart = JSON.parse(cartData);
        setCartItemsCount(Array.isArray(parsedCart) ? parsedCart.length : 0);
      } catch (e) {
        setCartItemsCount(0);
      }
    }
  }, [cafe]);

  const goBack = () => {
    history.push(`/m/${cafe}/${table}`);
  };

  const goToMealDetail = (meal, noPrice) => {
    history.push({
      pathname: "/meal",
      state: { cafe, meal, info, paket: false, noPrice },
    });
  };

  window.addEventListener("mousedown", (e) => {
    if (image != null && modalRef.current.contains(e.target)) {
      setImage(null);
    }
  });
  return (
    <>
      <div id="sticky-header" className="sticky-header not-showing">
        <div className="sticky-header__content">
          <div className="sticky-header__content__side">
            <div className="sticky-header__content__nav-btn">Menu</div>
          </div>
        </div>
      </div>
      {image && (
        <div
          id="myModal"
          ref={modalRef}
          className="modal"
          style={{ display: image != null ? "block" : "none" }}
        >
          {/* <span
            className="close"
            onClick={() => {
              setImage(null);
            }}
          >
            &times;
          </span> */}
          <img className="modal-content" id="img01" src={image} />
          {/* <div id="caption"></div> */}
        </div>
      )}
      <div
        className="sidepage-hero"
        style={{
          backgroundImage: `url(${category?.photo})`,
        }}
      >
        <div className="dmu_dark-overlay"></div>
        <h1 className="sidepage-hero__title">
          {lang == "tr"
            ? category.category
            : lang == "en"
            ? category.categoryEn
            : category.categoryAr}
        </h1>
        <a className="sidepage-hero__btn" onClick={goBack}>
          Menu
        </a>
      </div>
      {category?.items.map((item) => (
        <div
          className="items-container"
          onClick={() => {
            goToMealDetail(item, category.noPrice);
          }}
        >
          <div className="item-box  tem-box-image">
            <img
              className="item-image swiper-thumb"
              src={item.photo}
              onClick={(e) => {
                e.stopPropagation();
                setImage(item.photo);
              }}
              data-title="Breakfast Tray"
              data-desc={
                lang == "tr"
                  ? item.description
                  : lang == "en"
                  ? item.descriptionEn
                  : item.descriptionAr
              }
              data-image={item.photo}
            />
            <div className="item-content">
              <div className="primary-content">
                <div className="primary-head">
                  <div className="primary-headtext">
                    <h4 className="primary-title w-image">
                      {lang == "tr"
                        ? item.name
                        : lang == "en"
                        ? item.nameEn
                        : item.nameAr}
                    </h4>
                  </div>
                  {item.price != null && item.price != "" && (
                    <div className="price-box">
                      <div className="price-content --item">
                        {category.noPrice != true ? (
                          <>
                            <div className="price">{item.price}</div>
                            <div className="currency">₺</div>
                          </>
                        ) : (
                          <div className="currency">
                            {lang == "tr"
                              ? "Danışınız"
                              : lang == "en"
                              ? "Contact us"
                              : "اتصل بنا"}
                          </div>
                        )}
                      </div>

                      {!info?.hasOnlyMenu && (
                        <div
                          className="add-to-cart-icon"
                          style={{
                            marginLeft: "10px",
                            border: "1px solid #d43031",
                            borderRadius: "50%",
                            width: "26px",
                            height: "26px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: info.color || "#d43031",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          <i
                            className="fas fa-plus"
                            style={{ lineHeight: 1 }}
                          ></i>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {item.description != null && item.description.trim() != "" && (
                  <p style={{ width: "90%" }}>
                    ({" "}
                    {lang == "tr"
                      ? item.description
                      : lang == "en"
                      ? item.descriptionEn
                      : item.descriptionAr}{" "}
                    )
                  </p>
                )}
              </div>
              <div className="secondary-content">
                {item.addOptions
                  ?.sort((a, b) => {
                    if (parseFloat(a.sortOrder) < parseFloat(b.sortOrder))
                      return -1;
                    else return 1;
                  })
                  .map((opt, i) => (
                    <div className="variation-item">
                      <div className="variation-name">
                        {lang == "tr"
                          ? opt.name
                          : lang == "en"
                          ? opt.nameEn
                          : opt.nameAr}
                      </div>
                      {opt.price != null && opt.price != "" && (
                        <div className="price-box">
                          <div className="price-content --variation">
                            <div className="price">{opt.price}</div>
                            <div className="currency">₺</div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ))}
      <div className="footer-dmenu">
        <a href="https://dbateknoloji.com" target="_blank">
          <img src={logo} style={{ width: 60 }} />
        </a>
        <br />
        <small>DBA Teknoloji Yazılım &copy; {new Date().getFullYear()}</small>
      </div>

      {!info?.hasOnlyMenu && (
        <div
          className="floating-cart-button"
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            zIndex: 999,
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            backgroundColor: info.color || "#d43031",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            cursor: "pointer",
          }}
          onClick={() => {
            history.push({
              pathname: "/cart",
              state: { cafe, table, info, noFooter: true },
            });
          }}
        >
          <i
            className="fas fa-shopping-cart"
            style={{ color: "white", fontSize: "24px" }}
          ></i>
          {cartItemsCount > 0 && (
            <div
              style={{
                position: "absolute",
                top: "-8px",
                right: "-8px",
                backgroundColor: "white",
                color: info.color || "#d43031",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                border: `1px solid ${info.color || "#d43031"}`,
              }}
            >
              {cartItemsCount}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Category;
